// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  envName: 'development',

  //urlWebManagement: 'http://localhost:4200', // URL de pruebas
  urlWebManagement: 'http://web.medplus.net.co:8778/sucursal_web', // URL de producción

  //urlApi: 'https://wspr.medplus.net.co/of_virtual', // URL de pruebas
  urlApi: 'https://web.medplus.net.co/sucursal_api', // URL de producción

  //urlManagement: 'https://wspr.medplus.net.co/of_virtual', // URL de pruebas
  urlManagement: 'https://web.medplus.net.co/sucursal_api', // URL de producción

  //urlPortalPagos : 'http://localhost:8283', // URL de pruebas
  urlPortalPagos: 'https://web.medplus.net.co/portal_pagos', // URL de producción

  urlGenerarFacturaPDF: "http://medplusfe.medplus.com.co:5000/api/factura/representacion",

  REQUEST_REFUND: {
    TYPES_OF_FILES: {
      BANK_CERTIFICATE: "Certificación Bancaria",
      CLINIC_HISTORY: "Historia clínica",
      ORIGINAL_INVOICE: "Factura original",
      EXAM_RESULTS: "Resultado exámenes",
      EVOLUTION_SHEET_FOR_SESSION: "Hoja de evolución por sesión",
      MEDICAL_FORMULA_DIAGNOSIS: "Formula médica con diagnóstico",
      PROCEDURE_DESCRIPTION: "Descripción del procedimiento",
      SURGICAL_DESCRIPTION_MEDICAL_ORDER: "Descripción quirúrgica u Orden médica",
      SURGICAL_DESCRIPTION: "Descripción quirúrgica",
      CLINICAL_HISTORY_EVOLUTION: "Historia Clínica o Evolución",
      AMBULANCE_TRANSFER_REPORT: "Reporte traslado de ambulancia"
    }
  },
  LABORATORY_TESTS: {
    LABCORE_PARAMS: {
      ORDER_COUNT: "10",
      REPORT_CODE: "RP001"
    },
    ORDER_DATE: 5
  }
};



// WEBPACK FOOTER //
// /app/src/environments/environment.ts